module.exports = __webpack_public_path__ + "media/application/images/svgs/trello-9add9452dbbc02e06c2c4abedcddd211.svg";